import { BaySide } from '@warebee/shared/data-access-api-dto';
import { MappingValueResolver } from './valueResolverBase';

export const baySideValueResolver: MappingValueResolver<BaySide> = {
  left: BaySide.LEFT,
  right: BaySide.RIGHT,
};